<template>
  <div v-if="loaded">
    <div class="hero" v-if="hasBannerFlag">
        <vue-plyr ref="plyr"  :options="options" :key="$route.fullPath">
            <video id="heroPlayer" data-keepplaying muted loop playsinline autoplay preload="auto">
                <source src="../assets/images/new/hero-video.mp4" type="video/mp4">
            </video>
        </vue-plyr>

        <div class="hero__content">
            <div class="hero__content-left">
                <h1 v-html="$t('newhome.hero.left')">
                </h1>
                <a :href="landingPage" class="hero__cta mobile-hidden" v-if="!isLoggedIn">
                    {{ $t("newhome.hero.button") }}
                </a>
            </div>
            <div class="hero__content--bottom">
                <ul>
                    <li>
                        <div class="list-image">
                            <img src="../assets/images/new/play.svg" :alt="$t('home.banner.title1')">
                        </div>
                        <div class="list-data">
                            <h2 :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.hero.title1") }}</h2>
                            <!-- <p>{{ $t("home.banner.description1") }}</p> -->
                        </div>
                    </li>
                     <li>
                        <div class="list-image">
                            <img src="../assets/images/new/ebook.svg" :alt="$t('home.banner.title2')">
                        </div>
                        <div class="list-data">
                            <h2 :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.hero.title2") }}</h2>
                            <!-- <p>{{ $t("home.banner.description2") }}</p> -->
                        </div>
                    </li>
                    <li v-if="!(currentCountry === 'AE' && helpers.portal_name === 'Fitlandclub')">
                        <div class="list-image">
                            <img src="../assets/images/new/apps.svg" :alt="$t('home.banner.title3')">
                        </div>
                        <div class="list-data">
                            <h2 :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.hero.title3") }}</h2>
                            <!-- <p>{{ $t("home.banner.description3") }}</p> -->
                        </div>
                    </li>
                    <li>
                        <div class="list-image">
                            <img src="../assets/images/new/tutorial.svg" :alt="$t('home.banner.title4')">
                        </div>
                        <div class="list-data">
                            <h2 :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.hero.title4") }}</h2>
                            <!-- <p>{{ $t("home.banner.description4") }}</p> -->
                        </div>
                    </li>
                </ul>
            </div>
            <a :href="landingPage" class="hero__cta mobile-show" v-if="!isLoggedIn" :class="[currentLanguage == 'AR' ? 'rtlText': '']">
                {{ $t("newhome.hero.button") }}
            </a>
        </div>
    </div>


    <div class="services" v-if="$route.params.id == 4 || !$route.params.id">
        <div class="section__inner">
            <div class="services__inner">
                <h2 class="services__headline" :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.headline.title") }}</h2>

                <div class="services-items">
                    <div class="item-col">
                        <div class="col-image">
                            <svg width="30" height="18" viewBox="0 0 30 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M19.2564 0.890247L19.9314 1.04493L24.0048 1.98712L27.0095 2.68087C28.6418 3.05847 28.9045 3.11922 28.9966 3.27855C29.0142 3.3091 29.0256 3.34327 29.0392 3.384C29.0624 3.45449 29.0686 3.5295 29.0572 3.60284C29.0458 3.67618 29.0171 3.74577 28.9736 3.80587C27.2017 6.29025 26.072 8.06681 25.6267 9.08869C23.4283 14.2918 19.6548 17.1652 15.0001 17.1652C10.3455 17.1652 6.57201 14.2918 4.37358 9.07931C3.92826 8.06212 2.79858 6.28556 1.0267 3.80587C0.983143 3.74577 0.95448 3.67618 0.94307 3.60284C0.931661 3.5295 0.937833 3.45449 0.961078 3.384C1.04545 3.13087 1.04545 3.13087 3.70326 2.51681L10.7392 0.890247C11.1783 0.791121 11.6369 0.825399 12.0564 0.988685L14.522 1.959C14.827 2.08322 15.1686 2.08322 15.4736 1.959L17.9392 0.988685C18.3587 0.825736 18.8173 0.791466 19.2564 0.890247ZM7.56108 8.69962C10.8798 11.4371 12.7876 12.009 15.0001 12.009C17.2126 12.009 19.1205 11.4371 22.4392 8.69962L23.8173 7.509C24.3939 6.99337 25.0126 6.41681 25.6736 5.77931C22.9173 6.38869 19.0595 6.33712 16.3783 6.29962C15.858 6.29493 14.1423 6.29493 13.622 6.29962C10.6876 6.34181 7.05951 6.37462 4.33139 5.784C4.99233 6.4215 5.60639 6.99337 6.18295 7.509L7.56108 8.69962Z" fill="#29c5b2"/>
                                </svg>
                        </div>
                        <div class="col-data">
                            <div class="data-title" :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.headline.subtitle1") }}</div>
                            <ul>
                                <li :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.headline.line1_1") }}</li>
                                <li :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.headline.line1_2") }}</li>
                                <li :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.headline.line1_3") }}</li>
                                <li :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.headline.line1_4") }}</li>
                                <li :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.headline.line1_5") }}</li>
                                <li :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.headline.line1_6") }}</li>
                            </ul>
                        </div>
                    </div>
                    <div class="item-col">
                        <div class="col-image">
                            <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.6955 6.61876C17.113 7.78251 17.388 8.99001 17.388 10.1813C17.388 13.1338 15.7555 15.3713 14.2367 16.8225C15.873 16.8638 18.013 16.5363 19.643 14.905C22.6805 11.8675 22.7855 5.47751 22.7855 5.47751C22.7855 5.47751 19.628 5.53126 16.6955 6.61876ZM6.65299 6.61876C3.72174 5.53126 0.562988 5.47626 0.562988 5.47626C0.562988 5.47626 0.667988 11.8663 3.70549 14.9038C5.33549 16.535 7.47549 16.8638 9.11174 16.8213C7.59174 15.3713 5.96049 13.1338 5.96049 10.18C5.96049 8.99001 6.23549 7.78251 6.65299 6.61876Z" fill="#29c5b2"/>
                            <path d="M16.1192 9.86376C16.1192 5.5675 11.6742 0.973755 11.6742 0.973755C11.6742 0.973755 7.22925 5.5675 7.22925 9.86376C7.22925 12.66 9.10925 14.635 10.4242 15.6775V22.5025H12.9242V15.6775C14.2392 14.635 16.1192 12.66 16.1192 9.86376Z" fill="#29c5b2"/>
                            </svg>
                        </div>
                        <div class="col-data">
                            <div class="data-title" :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.headline.subtitle2") }}</div>
                            <ul>
                                <li :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.headline.line2_1") }}</li>
                                <li :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.headline.line2_2") }}</li>
                                <li :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.headline.line2_3") }}</li>
                            </ul>
                        </div>
                    </div>
                    <div class="item-col">
                        <div class="col-image">
                            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_17_431)">
                                <path d="M20.7719 9.2952L22.5023 0H21.0359L19.3055 9.2952H16.1519L16.5839 0H15.1439L14.7095 9.2952H0.333496V9.9984C0.340451 11.8617 0.794645 13.6962 1.6579 15.3475C2.52115 16.9988 3.76823 18.4188 5.2943 19.488V23C5.2943 23.5523 5.74201 24 6.2943 24H18.3727C18.925 24 19.3727 23.5523 19.3727 23V19.488C20.8992 18.4192 22.1466 16.9994 23.0099 15.3479C23.8732 13.6965 24.3271 11.8619 24.3335 9.9984V9.2952H20.7719ZM17.9327 21.5912C17.9327 22.1435 17.485 22.5912 16.9327 22.5912H7.7343C7.18201 22.5912 6.7343 22.1435 6.7343 21.5912V20.3664C8.46572 21.2591 10.3855 21.7249 12.3335 21.7249C14.2815 21.7249 16.2013 21.2591 17.9327 20.3664V21.5912Z" fill="#29c5b2"/>
                                </g>
                                <defs>
                                <clipPath id="clip0_17_431">
                                <rect width="24" height="24" fill="white" transform="translate(0.333496)"/>
                                </clipPath>
                                </defs>
                                </svg>
                        </div>
                        <div class="col-data">
                            <div class="data-title" :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.headline.subtitle3") }}</div>
                            <ul>
                                <li :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.headline.line3_1") }}</li>
                                <li :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.headline.line3_2") }}</li>
                                <li :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.headline.line3_3") }}</li>
                                <li :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.headline.line3_4") }}</li>
                                <li :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.headline.line3_5") }}</li>
                            </ul>
                        </div>
                    </div>
                    <div class="item-col">
                        <div class="col-image">
                            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.2875 16.575L0.85355 15.1411C0.658287 14.9458 0.658287 14.6292 0.85355 14.4339L1.93394 13.3536C2.12921 13.1583 2.44579 13.1583 2.64105 13.3536L6.39644 17.1089C6.59171 17.3042 6.90829 17.3042 7.10355 17.1089L17.1089 7.10355C17.3042 6.90829 17.3042 6.59171 17.1089 6.39645L13.3536 2.64105C13.1583 2.44579 13.1583 2.12921 13.3536 1.93395L14.4339 0.853553C14.6292 0.658291 14.9458 0.658291 15.1411 0.853554L16.575 2.2875L18.0089 0.853553C18.2042 0.658291 18.5208 0.658291 18.7161 0.853553L21.0375 3.175L22.4714 1.74105C22.6667 1.54579 22.9833 1.54579 23.1786 1.74105L24.2589 2.82145C24.4542 3.01671 24.4542 3.33329 24.2589 3.52855L22.825 4.9625L25.1464 7.28395C25.3417 7.47921 25.3417 7.79579 25.1464 7.99105L23.7125 9.425L25.1464 10.8589C25.3417 11.0542 25.3417 11.3708 25.1464 11.5661L24.0661 12.6464C23.8708 12.8417 23.5542 12.8417 23.3589 12.6464L19.6036 8.89105C19.4083 8.69579 19.0917 8.69579 18.8964 8.89105L8.89105 18.8964C8.69579 19.0917 8.69579 19.4083 8.89105 19.6036L12.6464 23.3589C12.8417 23.5542 12.8417 23.8708 12.6464 24.0661L11.5661 25.1465C11.3708 25.3417 11.0542 25.3417 10.8589 25.1465L9.425 23.7125L7.99105 25.1465C7.79579 25.3417 7.47921 25.3417 7.28394 25.1465L4.9625 22.825L3.52855 24.259C3.33329 24.4542 3.0167 24.4542 2.82144 24.2589L1.74105 23.1786C1.54579 22.9833 1.54579 22.6667 1.74105 22.4715L3.175 21.0375L0.85355 18.7161C0.658289 18.5208 0.658287 18.2042 0.85355 18.0089L2.2875 16.575Z" fill="#29c5b2"/>
                            </svg>
                        </div>
                        <div class="col-data">
                            <div class="data-title" :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.headline.subtitle4") }}</div>
                            <ul>
                                <li :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.headline.line4_1") }}</li>
                                <li :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.headline.line4_2") }}</li>
                                <li v-if="!(currentCountry === 'AE' && helpers.portal_name === 'Fitlandclub')"
                                    :class="[currentLanguage == 'AR' ? 'rtlText': '']"
                                    >{{ $t("newhome.headline.line4_3") }}
                                </li>
                                <li :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.headline.line4_4") }}</li>
                                <li :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.headline.line4_5") }}</li>
<!--                                <li :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.headline.line4_6") }}</li>-->
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="service-banner">
                    <div class="service-banner__text">
                        <h2 class="service-banner__title" :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.banner.center.title") }}</h2>
                        <p class="service-banner__desc" :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.banner.center.description") }}</p>
                    </div>
                    <div class="service-banner__img">
                        <img src="../assets/images/new/phone.png" alt="At home, on the go, or in the gym">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div
      class="products"
      v-for="(category, index) in visibleCategories"
      :key="category.order"
    >
      <section class="section--products">
        <!-- if design type A, B, C, D -->
        <CarouselA
          v-if="category.design == 'A'"
          :products="category.products"
          :title="category.fullname"
          :categoryid="category.name"
        />
        <CarouselB
          v-if="category.design == 'B'"
          :products="category.products"
          :title="category.fullname"
          :categoryid="category.name"
        />
        <CarouselC
          v-if="category.design == 'C'"
          :products="category.products"
          :title="category.fullname"
          :categoryid="category.name"
        />
        <CarouselD
          v-if="category.design == 'D'"
          :products="category.products"
          :title="category.fullname"
          :categoryid="category.name"
        />
      </section>
    </div>

    <section class="section--our-categories" v-if="loaded">
      <div class="section__inner">
        <div class="our-categories section-box">
          <div class="our-categories__head section__head">
            <h3 :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("home.ourcategories.title") }}</h3>
          </div>

          <div class="our-categories__body">
            <div class="our-categories__list">
              <div v-for="category in visibleOurCategories" :key="category.id">
                <router-link :to="{
                    name: 'ProductCategory',
                    params: {
                      type: ($route.params.id || '1'),
                      title: category.item,
                      id: category.id
                    },
                }">
                    <div class="categories_link__item">
                        <img src="../assets/images/sample.png" alt=".">
                      <span>{{ category.item }}</span>
                      <!-- <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10.934"
                          height="18.018"
                          viewBox="0 0 10.934 18.018"
                      >
                          <path
                          d="M38.139,47.366,30.12,55.385a.99.99,0,0,1-1.4,0l-.935-.935a.99.99,0,0,1,0-1.4l6.355-6.385-6.355-6.385a.99.99,0,0,1,0-1.4l.935-.935a.99.99,0,0,1,1.4,0l8.019,8.019A.99.99,0,0,1,38.139,47.366Z"
                          transform="translate(-27.494 -37.657)"
                          />
                      </svg> -->
                    </div>
                </router-link>
                </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="footer-banner" v-if="$route.params.id == 4 || !$route.params.id">
        <div class="section__inner">
                <div class="footer-banner__text">
                    <h2 class="footer-banner__title" :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.banner.footer.title") }}</h2>
                    <p class="footer-banner__desc" :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.banner.footer.description") }}</p>

                    <div class="footer-banner__row">
                        <div class="col-icons">
                            <div class="icon-item">
                                <svg width="37" height="25" viewBox="0 0 37 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M30.6006 21.666C32.2581 21.666 33.5856 20.3235 33.5856 18.666L33.6006 3.66602C33.6006 2.00852 32.2581 0.666016 30.6006 0.666016H6.60059C4.94309 0.666016 3.60059 2.00852 3.60059 3.66602V18.666C3.60059 20.3235 4.94309 21.666 6.60059 21.666H0.600586V24.666H36.6006V21.666H30.6006ZM6.60059 3.66602H30.6006V18.666H6.60059V3.66602Z" fill="#0d264e"/>
                            </svg>
                            </div>
                            <div class="icon-item">
                                <svg width="25" height="33" viewBox="0 0 25 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.6006 0.666016H4.60059C2.39392 0.666016 0.600586 2.45935 0.600586 4.66602V28.666C0.600586 30.8727 2.39392 32.666 4.60059 32.666H20.6006C22.8073 32.666 24.6006 30.8727 24.6006 28.666V4.66602C24.6006 2.45935 22.8073 0.666016 20.6006 0.666016ZM15.2673 29.9993H9.93392V28.666H15.2673V29.9993ZM22.2673 25.9993H2.93392V4.66602H22.2673V25.9993Z" fill="#0d264e"/>
                                </svg>
                            </div>
                            <div class="icon-item">
                                <svg width="19" height="33" viewBox="0 0 19 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16.6006 32.666C17.131 32.666 17.6397 32.4553 18.0148 32.0802C18.3899 31.7052 18.6006 31.1964 18.6006 30.666V2.66602C18.6006 2.13558 18.3899 1.62687 18.0148 1.2518C17.6397 0.876729 17.131 0.666016 16.6006 0.666016H2.60059C2.07015 0.666016 1.56145 0.876729 1.18637 1.2518C0.8113 1.62687 0.600586 2.13558 0.600586 2.66602V30.666C0.600586 31.1964 0.8113 31.7052 1.18637 32.0802C1.56145 32.4553 2.07015 32.666 2.60059 32.666H16.6006ZM8.60059 29.542C8.5961 29.3917 8.62184 29.2419 8.67628 29.1017C8.73073 28.9615 8.81276 28.8336 8.91753 28.7256C9.0223 28.6177 9.14767 28.5319 9.28622 28.4733C9.42476 28.4147 9.57366 28.3845 9.72409 28.3845C9.87451 28.3845 10.0234 28.4147 10.162 28.4733C10.3005 28.5319 10.4259 28.6177 10.5306 28.7256C10.6354 28.8336 10.7174 28.9615 10.7719 29.1017C10.8263 29.2419 10.8521 29.3917 10.8476 29.542C10.8389 29.8342 10.7167 30.1115 10.5069 30.315C10.2972 30.5186 10.0164 30.6325 9.72409 30.6325C9.43179 30.6325 9.15099 30.5186 8.94124 30.315C8.73149 30.1115 8.6093 29.8342 8.60059 29.542ZM13.6006 2.66602C13.8658 2.66602 14.1202 2.77137 14.3077 2.95891C14.4952 3.14645 14.6006 3.4008 14.6006 3.66602C14.6006 3.93123 14.4952 4.18559 14.3077 4.37312C14.1202 4.56066 13.8658 4.66602 13.6006 4.66602H11.6006C11.3354 4.66602 11.081 4.56066 10.8935 4.37312C10.7059 4.18559 10.6006 3.93123 10.6006 3.66602C10.6006 3.4008 10.7059 3.14645 10.8935 2.95891C11.081 2.77137 11.3354 2.66602 11.6006 2.66602H13.6006ZM8.60059 3.66602C8.60059 3.93123 8.49523 4.18559 8.30769 4.37312C8.12016 4.56066 7.8658 4.66602 7.60059 4.66602C7.33537 4.66602 7.08102 4.56066 6.89348 4.37312C6.70594 4.18559 6.60059 3.93123 6.60059 3.66602C6.60059 3.4008 6.70594 3.14645 6.89348 2.95891C7.08102 2.77137 7.33537 2.66602 7.60059 2.66602C7.8658 2.66602 8.12016 2.77137 8.30769 2.95891C8.49523 3.14645 8.60059 3.4008 8.60059 3.66602ZM2.60059 6.66602H16.6006V26.666H2.60059V6.66602Z" fill="#0d264e"/>
                                    </svg>
                            </div>

                            <div class="icon-item">
                                <svg width="23" height="28" viewBox="0 0 23 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.5205 4.5861C16.0245 4.00514 16.4089 3.33032 16.6514 2.60041C16.894 1.8705 16.9899 1.09987 16.9338 0.332764C15.3863 0.45768 13.9498 1.18551 12.9338 2.35943C12.4473 2.92206 12.0786 3.5766 11.8495 4.28429C11.6205 4.99198 11.5358 5.73842 11.6005 6.47943C12.3553 6.48572 13.1015 6.31822 13.7813 5.98991C14.461 5.66159 15.0561 5.18126 15.5205 4.5861V4.5861ZM18.8805 14.5061C18.8894 13.4844 19.1585 12.4819 19.6624 11.593C20.1663 10.7042 20.8884 9.95844 21.7605 9.4261C21.2101 8.63308 20.4825 7.97921 19.6355 7.51633C18.7884 7.05345 17.8451 6.7943 16.8805 6.75943C14.8005 6.5461 12.8805 7.97276 11.7738 7.97276C10.6671 7.97276 9.10714 6.7861 7.3738 6.81276C6.24064 6.85009 5.1365 7.18047 4.16906 7.77168C3.20163 8.36289 2.40394 9.19474 1.8538 10.1861C-0.492865 14.2661 1.2538 20.3328 3.60047 23.6261C4.66713 25.2394 6.00047 27.0661 7.76047 26.9994C9.52047 26.9328 10.0938 25.9061 12.1338 25.9061C14.1738 25.9061 14.8005 26.9994 16.5338 26.9594C18.2671 26.9194 19.4938 25.3061 20.6138 23.6928C21.4072 22.5215 22.0269 21.2415 22.4538 19.8928C21.3971 19.4421 20.4956 18.6918 19.8605 17.7345C19.2255 16.7772 18.8848 15.6549 18.8805 14.5061V14.5061Z" fill="#0d264e"/>
                                </svg>
                            </div>
                            <div class="icon-item">
                                <svg width="25" height="30" viewBox="0 0 25 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.5678 2.69123L17.8475 0.382446C17.864 0.352826 17.8744 0.320262 17.8782 0.286613C17.882 0.252963 17.8792 0.218888 17.8699 0.186333C17.8606 0.153777 17.8449 0.123379 17.8238 0.0968729C17.8027 0.0703672 17.7766 0.0482734 17.747 0.0318529C17.6872 -0.00130974 17.6167 -0.00935062 17.5509 0.00949929C17.4852 0.0283492 17.4296 0.0725458 17.3964 0.132366L16.1025 2.46674C14.9985 1.98275 13.8061 1.73287 12.6007 1.73287C11.3952 1.73287 10.2028 1.98275 9.09883 2.46674L7.80485 0.132366C7.77169 0.0725458 7.71612 0.0283492 7.65037 0.00949929C7.58462 -0.00935061 7.51408 -0.00130973 7.45426 0.0318529C7.39444 0.0650156 7.35024 0.120584 7.33139 0.186333C7.31254 0.252082 7.32058 0.322626 7.35375 0.382446L8.63355 2.69125C7.41532 3.29174 6.386 4.21614 5.65849 5.36305C4.93099 6.50996 4.5334 7.83507 4.50933 9.19305H20.692C20.6679 7.83507 20.2703 6.50995 19.5428 5.36304C18.8153 4.21613 17.786 3.29173 16.5678 2.69123ZM8.86612 6.23203C8.73247 6.23203 8.60183 6.1924 8.4907 6.11815C8.37958 6.0439 8.29297 5.93836 8.24182 5.81489C8.19068 5.69142 8.1773 5.55555 8.20337 5.42447C8.22944 5.29339 8.2938 5.17299 8.3883 5.07848C8.48281 4.98398 8.60321 4.91962 8.73429 4.89355C8.86537 4.86748 9.00124 4.88086 9.12471 4.932C9.24819 4.98315 9.35372 5.06976 9.42797 5.18088C9.50222 5.29201 9.54185 5.42265 9.54185 5.5563C9.54165 5.73545 9.47039 5.90721 9.34371 6.03389C9.21703 6.16057 9.04527 6.23183 8.86612 6.23203ZM16.3352 6.23203C16.2015 6.23203 16.0709 6.1924 15.9597 6.11815C15.8486 6.0439 15.762 5.93836 15.7109 5.81489C15.6597 5.69142 15.6463 5.55555 15.6724 5.42447C15.6985 5.29339 15.7628 5.17299 15.8573 5.07848C15.9518 4.98398 16.0722 4.91962 16.2033 4.89355C16.3344 4.86748 16.4703 4.88086 16.5938 4.932C16.7172 4.98315 16.8228 5.06976 16.897 5.18088C16.9713 5.29201 17.0109 5.42265 17.0109 5.5563C17.0107 5.73545 16.9394 5.90721 16.8128 6.03389C16.6861 6.16057 16.5143 6.23183 16.3352 6.23203ZM4.50921 21.5614C4.50921 22.0802 4.71531 22.5777 5.08216 22.9446C5.44902 23.3114 5.94658 23.5175 6.46539 23.5175H7.76352V27.5188C7.76287 27.7574 7.80931 27.9938 7.90018 28.2145C7.99105 28.4351 8.12456 28.6357 8.29307 28.8046C8.46157 28.9736 8.66176 29.1077 8.88216 29.1991C9.10255 29.2906 9.33883 29.3377 9.57746 29.3377C9.81608 29.3377 10.0524 29.2906 10.2728 29.1991C10.4932 29.1077 10.6933 28.9736 10.8618 28.8046C11.0304 28.6357 11.1639 28.4351 11.2547 28.2145C11.3456 27.9938 11.392 27.7574 11.3914 27.5188V23.5175H13.8099V27.5188C13.8092 27.7574 13.8557 27.9938 13.9465 28.2145C14.0374 28.4351 14.1709 28.6357 14.3394 28.8046C14.5079 28.9736 14.7081 29.1077 14.9285 29.1991C15.1489 29.2906 15.3852 29.3377 15.6238 29.3377C15.8624 29.3377 16.0987 29.2906 16.3191 29.1991C16.5395 29.1077 16.7397 28.9736 16.9082 28.8046C17.0767 28.6357 17.2102 28.4351 17.3011 28.2145C17.392 27.9938 17.4384 27.7574 17.4378 27.5188V23.5175H18.7359C19.2548 23.5175 19.7523 23.3114 20.1192 22.9446C20.486 22.5777 20.6921 22.0802 20.6921 21.5614V9.83318H4.50921V21.5614ZM2.01951 9.52197C1.53859 9.52251 1.07752 9.7138 0.737461 10.0539C0.397401 10.3939 0.206117 10.855 0.205573 11.3359V18.8939C0.204926 19.1325 0.251368 19.3689 0.342237 19.5895C0.433106 19.8102 0.566617 20.0107 0.735121 20.1797C0.903626 20.3487 1.10381 20.4827 1.32421 20.5742C1.54461 20.6656 1.78089 20.7127 2.01951 20.7127C2.25814 20.7127 2.49442 20.6656 2.71482 20.5742C2.93521 20.4827 3.1354 20.3487 3.3039 20.1797C3.47241 20.0107 3.60592 19.8102 3.69679 19.5895C3.78766 19.3689 3.8341 19.1325 3.83345 18.8939V11.3359C3.83291 10.855 3.64162 10.3939 3.30156 10.0539C2.9615 9.7138 2.50043 9.52251 2.01951 9.52197ZM23.1818 9.52197C22.7008 9.52251 22.2398 9.7138 21.8997 10.0539C21.5597 10.3939 21.3684 10.855 21.3678 11.3359V18.8939C21.3672 19.1325 21.4136 19.3689 21.5045 19.5895C21.5954 19.8102 21.7289 20.0107 21.8974 20.1797C22.0659 20.3487 22.2661 20.4827 22.4865 20.5742C22.7069 20.6656 22.9431 20.7127 23.1818 20.7127C23.4204 20.7127 23.6567 20.6656 23.8771 20.5742C24.0975 20.4827 24.2977 20.3487 24.4662 20.1797C24.6347 20.0107 24.7682 19.8102 24.859 19.5895C24.9499 19.3689 24.9964 19.1325 24.9957 18.8939V11.3359C24.9952 10.855 24.8039 10.3939 24.4638 10.0539C24.1238 9.7138 23.6627 9.52251 23.1818 9.52197Z" fill="#0d264e"/>
                                </svg>
                            </div>
                            <div class="icon-item">
                                <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M26.934 0.332764L12.534 2.4661V13.1328L26.934 12.9994V0.332764ZM11.2007 14.3328L0.267334 14.1994V23.2661L11.0673 24.7328L11.2007 14.3328ZM0.267334 4.0661V13.1328H11.0673V2.59943L0.267334 4.0661ZM12.4007 14.3328V24.8661L26.934 26.9994V14.4661L12.4007 14.3328Z" fill="#0d264e"/>
                                </svg>
                            </div>
                        </div>
                        <div class="col-image">
                            <a :href="landingPage">
                              <button class="footer-banner__cta" v-if="!isLoggedIn" :class="[currentLanguage == 'AR' ? 'rtlText': '']">{{ $t("newhome.banner.footer.button") }}</button>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="footer-banner__img">
                    <img src="../assets/images/new/phone-v2.png" alt="At home, on the go, or in the gym">
                </div>
        </div>
    </div>

    <cookie-law theme="portal" :buttonText="$t('cookie.btn')">
      <template #message>
        <div :class="[currentLanguage == 'AR' ? 'rtlText': '']">
            {{ $t("cookie.message") }}
            <router-link to="cookies-policy" :class="[currentLanguage == 'AR' ? 'rtlText': '']">
                {{ $t("cookie.link") }}
            </router-link>
        </div>
      </template>
    </cookie-law>
  </div>
</template>

<script>
import CookieLaw from '../components/CookieLaw.vue';
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import { helpers } from '../helper/portal_config';
import EventBus from '../helper/event_bus';

import CarouselA from '../components/CarouselA';
import CarouselB from '../components/CarouselB';
import CarouselC from '../components/CarouselC';
import CarouselD from '../components/CarouselD';

// api to get products
const apiPrTypeMethod = 'getProductListByType';

export default {
  name: 'Home',
  title: helpers.portal_name,
  data() {
    return {
      helpers: '',
      categories: [],
      allCategories: [],
      hasBannerFlag: null,
      currentLanguage: "",
      currentCountry: "",
      options: { quality: { default: '1080p' } },
      loaded: false,
    };
  },
  components: {
    CarouselA,
    CarouselB,
    CarouselC,
    CarouselD,
    CookieLaw
  },
  methods: {
    checkIsLogged() {
      // if you are not login than showed modal
      if (!this.isLoggedIn) {
        EventBus.$emit('SHOW_SIGNIN_MODAL');
      }
    },
    setProducts(types) {
      const keys = Object.keys(types);
      keys.forEach((element, index) => {
        types[element].fullname = element;
        this.allCategories.push(types[element]);
      });
      // filtered only homepage
      const categoriesFiltered = this.allCategories.filter((item) => item.homepage > 0);
      // sorting homepage categories
      this.sortProducts(categoriesFiltered);
    },
    sortProducts(filteredProducts) {
      filteredProducts.sort((a, b) => a.homepage - b.homepage);
      filteredProducts = this.slicesProducts(filteredProducts);
      this.allCategories = filteredProducts;
    },
    slicesProducts(products) {
      return products.map((item) => {
        item.products = item.products.slice(0, item.max_products);
        return item;
      });
    },
    sortCategories(categoriesLocal) {
      categoriesLocal.sort((a, b) => a.order - b.order);
      this.categories = categoriesLocal;
    },
    hasBanner() {
        let banner = document.querySelector('.page-header__menu li.is-active a');
        let type = banner.getAttribute('href').substr(banner.getAttribute('href').length-1, banner.getAttribute('href').length);
        console.log( type);
        return helpers.menu.some(function(item) {
            return (item.type == type && item.isActive == true && item.banner == 1);
        });
    },
    playHeroVideo() {
      this.$nextTick(() => {
        const player = this.$refs.plyr?.player;
        const video = document.getElementById('heroPlayer');

        if (video) {
          video.muted = true;
          video.load();
        }

        const playPromise = player?.play ? player.play() : video?.play();
        if (playPromise?.catch) {
          playPromise.catch(() => {});
        }
      });
    },
    setCurrentCountry() {
      const { host } = window.location;
      this.currentCountry = host.split('.')[0].slice(0,2).toUpperCase();
    },
    setCurrentLanguage() {
      var lang = "";
      const { host } = window.location;
      var country = host.split('.')[0].slice(0,2).toUpperCase();
      if (helpers.countryDefaultLanguage.hasOwnProperty(country)) {
        lang = helpers.countryDefaultLanguage[country].toUpperCase();
      } else {
        lang = country.toUpperCase();
      }
      this.currentLanguage = lang;
    },
    async fetchCategories() {
      // check user was logged and send access_code as a parameter.
      this.loaded = false;
      let apiUrl = null;
      if (this.isLoggedIn) {
        apiUrl = `https://api.hubdelivery.io/store/${apiPrTypeMethod}?portal_name=${helpers.portal_name
        }&country=${this.currentCountry}&language=${this.currentLanguage}&product_type=${this.$route.params.id || helpers.portal_type
        }&access_code=${this.accessCode}`;
      } else {
        apiUrl = `https://api.hubdelivery.io/store/${apiPrTypeMethod}?portal_name=${helpers.portal_name
        }&country=${this.currentCountry}&language=${this.currentLanguage}&product_type=${this.$route.params.id || helpers.portal_type
        }`;
      }

      await axios
        .get(
            apiUrl
        )
        .then((response) => {
          if (response.data.treatment === 1) {
            const { categories } = response.data;
            const types = categories;
            this.setProducts(types);

            // upload categories
            const categoriesKeys = Object.keys(categories);
            const categoriesLocal = [];
            categoriesKeys.forEach((element, index) => {
              const obj = {
                id: types[element].name,
                item: element,
                order: types[element].order,
              };
              categoriesLocal.push(obj);
            });
            this.sortCategories(categoriesLocal);
            this.loaded=true;
            this.playHeroVideo();
          }
        });
    }
  },
  computed: {
    ...mapGetters({
      accessCode: 'globals/accessCode',
      isLoggedIn: 'globals/isLoggedIn',
    }),
    landingPage: function() {
        let country = this.currentCountry;
        return helpers.landingUrl[0][country];
    },
    visibleCategories() {
      if (this.currentCountry === 'AE' && this.helpers.portal_name === 'Fitlandclub') {
          return this.allCategories.filter((_, index) => index !== 1);
      }
      return this.allCategories;
    },
    visibleOurCategories() {
      const ordered = (this.categories || []).filter(
        (c) => c && c.order != null
      )

      if (this.currentCountry === 'AE' && this.helpers.portal_name === 'Fitlandclub') {
        return ordered.filter((_, index) => index !== 1)
      }
      return ordered
    }
  },
  watch: {
    $route(to, from) {
      this.allCategories = [];
      this.categories = [];
      this.fetchCategories();
    },
  },
  created() {
    this.helpers = helpers;

    this.setCurrentLanguage();
    this.setCurrentCountry();
    this.fetchCategories();
  },
  mounted() {
    this.hasBannerFlag = this.hasBanner();
    this.playHeroVideo();
  },
};
</script>

<style>
.Cookie--portal {
    background: #000;
    padding: 8px 25px;
    box-shadow: 0 -10px 25px rgba(0, 0, 0, 0.1);
}

.Cookie--portal {
    color: #fff;
    font-size: 14px;
}

.Cookie--portal a {
    color: #fff;
    font-size: 14px;
    text-decoration: underline;
}

.Cookie--portal a:hover {
    color: #ffdd3d;
}

.Cookie--portal .Cookie__button {
  background: #222;
  color: #ffdd3d;
  border-radius: 5px;
  padding: 10px 35px;
}

.Cookie--portal .Cookie__button:hover {
  background: #ffdd3d;
  color: #222;
}

@media (max-width: 800px) {
    .Cookie--portal .Cookie__button {
        margin-bottom: 0;
    }

    .Cookie--portal .Cookie__content {
        margin: 0;
    }

    .Cookie--portal .Cookie__button {
        font-size: 12px;
    }

    .Cookie--portal .Cookie__buttons {
        margin-top: 5px;
    }
}

.plyr--video {
  height: 100%;
}

@media (max-width: 767px) {
.plyr--video {
    z-index: 300;
    position: absolute;
    width: 100%;
}
}

@media (max-height: 767px) {
.plyr--video {
    z-index: 300;
    position: absolute;
    width: 100%;
}
}

.plyr {
    align-items:stretch;
}

.plyr--full-ui.plyr--video .plyr__control--overlaid {
    display: none !important;
}

.plyr__controls {
display: none !important;
}
</style>
